import React, { useContext } from 'react';
import { ToastContext } from '../context/ToastContext';
import './ToastContainer.css';

export const ToastContainer = () => {
    const { toasts, removeToast } = useContext(ToastContext);

    const getIcon = (type) => {
        const icons = {
            'welcome': '👋',
            'chapter': '📖',
            'book': '🎉',
            'achievement': '🏆',
            'success': '✅',
            'error': '❌',
            'info': 'ℹ️'
        };
        return icons[type] || icons['info'];
    };

    return (
        <div className="toast-container">
            {toasts.map(toast => (
                <div key={toast.id} className={`toast toast-${toast.type}`}>
                    <span className="toast-icon">{getIcon(toast.type)}</span>
                    <span className="toast-message">{toast.message}</span>
                    <button
                        className="toast-close"
                        onClick={() => removeToast(toast.id)}
                        aria-label="Cerrar notificación"
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
};
